import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { CardProps } from "./types";

const DynamicDashboardCard = dynamic(() => import("./DashboardCardSsr").then((mod) => mod.DashboardCardSsr), {
  ssr: false,
});

export const DashboardCard = forwardRef<HTMLDivElement, CardProps>((props, ref) => (
  <DynamicDashboardCard {...props} forwardedRef={ref} />
));

DashboardCard.displayName = "DashboardCard";
